import { render, staticRenderFns } from "./QuestionFormActionButtons.vue?vue&type=template&id=7ea9605e&scoped=true"
import script from "./QuestionFormActionButtons.vue?vue&type=script&lang=js"
export * from "./QuestionFormActionButtons.vue?vue&type=script&lang=js"
import style0 from "./QuestionFormActionButtons.vue?vue&type=style&index=0&id=7ea9605e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea9605e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea9605e')) {
      api.createRecord('7ea9605e', component.options)
    } else {
      api.reload('7ea9605e', component.options)
    }
    module.hot.accept("./QuestionFormActionButtons.vue?vue&type=template&id=7ea9605e&scoped=true", function () {
      api.rerender('7ea9605e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionFormActionButtons.vue"
export default component.exports